import React from "react";
import UsersAndGroupsModal from "./UsersAndGroupsModal";
import { closeUsersAndGroupsModal, useUsersAndGroupsTrigger } from "./store";

export const UsersAndGroupsHost: React.FC = () => {
  const trigger = useUsersAndGroupsTrigger();
  if (!trigger) return null;
  return (
    <UsersAndGroupsModal trigger={trigger} onClose={closeUsersAndGroupsModal} />
  );
};

export { openUsersAndGroupsModal, closeUsersAndGroupsModal } from "./store";
